import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import Vue from 'vue';
import Chat from '@/models/list/chat.js';

export default class Chats {
  /**
   * @param {String} urlPrefix (ex. 'activity', 'event')
   * @param {Number} entityId (ex. activity.id, event.id)
   * @param {Array} list just array from server
   */
  constructor(urlPrefix, entityId, list) {
    this.url = `/telegram/${urlPrefix}/${entityId}`;
    this.list = (list || []).map((chat) => new Chat(chat));
  }

  async create(params) {
    return rHandler(
      apiService.post(this.url, params),
      (response) => {
        this.list.push(new Chat(response.data.data));
        Vue.$toast.success('Чат успешно создан');
        return { response };
      },
      (error) => ({ error }),
    );
  }

  async remove(id) {
    const chat = this.list.find((item) => item.id === id);
    if (!chat) return null;
    const { response, error } = await chat.remove();
    if (!error) {
      this.list = this.list.filter((item) => item.id !== chat.id);
      Vue.$toast.success('Чат удалён');
    }
    return response;
  }

  index() {
    return rHandler(
      apiService.get(this.url),
      (response) => {
        this.list = (response?.data || []).map((chat) => new Chat(chat));
        return { response };
      },
      (error) => ({ error }),
    );
  }
}
